import API from "@/js/api"
import {COLORS} from "@/style_vars"
const style = {
  state: () => ({
    colors:{
      ...COLORS
    },
    loadingImage:false,
    style:{
        bg_color:"",
        bt_color:"",
        bt_fill:"empty",
        bt_text_color:"#fff",
        bg_gradient:"green",
        bt_shape:"smooth",
        img_border:10
    },
    srcImage:""   
  }),
  mutations: {
    setLoadingImage: (state,loading) => state.loadingImage = loading,
    setImage(state,imageUrl){
        state.srcImage = imageUrl;
    },
    setStyle(state,styleFromApi){  
        state.style = styleFromApi
    },
    setBtnShape(state,bt_shape){
        state.style.bt_shape = bt_shape
    },
    setBtnFill(state,fill){
        state.style.bt_fill = fill
    },
    setGradient(state,gradientClass){
      state.style.bg_color = gradientClass 
    },
  },
  actions:{
    getImage({commit},name){
      commit('setLoadingImage',true)
      return API.user.get(name).then((result)=>{
        commit('setLoadingImage',false)
        if(result.image_url){
          commit('setImage', "https://mis-redes-bucket.s3.amazonaws.com/imgs/"+result.image_url);
        }
      })
    },
    getStyle({commit},name){
      return API.style.get(name).then((res)=>{
        commit('setStyle',JSON.parse(res.json))
      })
    },
    saveStyle({dispatch,getters,state}){
      if(!state.saving){
        state.saving = true;
        var toSave =  Object.assign({}, state.style)
        //format the data to add the order the user gave 
        API.style.post(getters.userName,{"style":toSave}).then(()=>{
          //we finish saving
          state.saving = false;
          if(state.hasNotSavedChanges){
            state.hasNotSavedChanges = false;
            dispatch('saveStyle')
          }
        })
      } else {
        this.hasNotSavedChanges = true;
      }
    },
  },
  getters: {
    loadingImage:state => state.loadingImage,
    style: state=> state.style,
    srcImage: state => state.srcImage,
    getColorsArray : state=> Object.values(state.colors),
  }
}
export default style